import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DeviceSize, SystemService } from '../../services/system.service';

@Injectable({
  providedIn: 'root'
})
export class PageHeaderService {

  public port = new Subject<boolean>();
  public isSmallSize$ = new BehaviorSubject<boolean>(false);
  public actionsExists$ = new BehaviorSubject<boolean>(false);

  constructor(
    sysService: SystemService
  ) {
    sysService.deviceSize$.subscribe(size => {
      this.isSmallSize$.next( [ DeviceSize.SM, DeviceSize.MD ].includes(size) );
    });
  }
}
